
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 1a7 7 0 00-7 7c0 3.353-.717 5.435-1.378 6.646a5.938 5.938 0 01-.88 1.244 3.036 3.036 0 01-.305.284l-.003.002A1 1 0 003 18h18a1 1 0 00.566-1.824l-.002-.002a3.026 3.026 0 01-.306-.283 5.939 5.939 0 01-.88-1.245C19.718 13.435 19 11.353 19 8a7 7 0 00-7-7zm6.85 15H5.15c.075-.125.152-.257.228-.396C6.218 14.065 7 11.647 7 8a5 5 0 1110 0c0 3.647.783 6.065 1.622 7.604.076.14.153.271.229.396zm-7.715 4.498a1 1 0 00-1.73 1.004 3 3 0 005.19 0 1 1 0 00-1.73-1.004 1 1 0 01-1.73 0z","fill":"#04080E"}})])
          )
        }
      }
    